import { useState, useMemo } from 'react';

const ITEMS_POR_PAGINA = 10;

export default function usePaginacion(datos) {
  const [pagina, setPagina] = useState(1);

  const totalPaginas = Math.ceil(datos.length / ITEMS_POR_PAGINA);

  const datosPaginados = useMemo(() => {
    const inicio = (pagina - 1) * ITEMS_POR_PAGINA;
    return datos.slice(inicio, inicio + ITEMS_POR_PAGINA);
  }, [datos, pagina]);

  const cambiarPagina = (nuevaPagina) => {
    if (nuevaPagina >= 1 && nuevaPagina <= totalPaginas) {
      setPagina(nuevaPagina);
    }
  };

  return { datosPaginados, pagina, totalPaginas, cambiarPagina, setPagina };
}